define('OutSystems/ClientRuntime/NativeApplicationInfo',["require", "exports", "tslib", "./NativeHelper"], function (require, exports, tslib_1, NativeHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isVersionGreaterOrEqualTo = exports.getAppVersionNumber = exports.getAppVersion = exports.getNativeShellVersion = exports.getPlatformVersion = void 0;
    function getNativeApplicationInfo() {
        var w = window;
        if (w && w.OutSystemsNative && w.OutSystemsNative.ApplicationInfo) {
            return w.OutSystemsNative.ApplicationInfo;
        }
    }
    function getPlatformVersion() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, NativeHelper_1.ensureNativeReady)()];
                    case 1:
                        _a.sent();
                        return [2, new Promise(function (resolve, reject) {
                                var appInfo = getNativeApplicationInfo();
                                if (!appInfo) {
                                    return reject(new Error("NativeAppInfo API is not available"));
                                }
                                appInfo.getPlatformVersion(resolve, reject);
                            })];
                }
            });
        });
    }
    exports.getPlatformVersion = getPlatformVersion;
    function getNativeShellVersion() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, NativeHelper_1.ensureNativeReady)()];
                    case 1:
                        _a.sent();
                        return [2, new Promise(function (resolve, reject) {
                                var appInfo = getNativeApplicationInfo();
                                if (!appInfo) {
                                    return reject(new Error("NativeAppInfo API is not available"));
                                }
                                appInfo.getNativeShellVersion(resolve, reject);
                            })];
                }
            });
        });
    }
    exports.getNativeShellVersion = getNativeShellVersion;
    function getAppVersion() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, NativeHelper_1.ensureNativeReady)()];
                    case 1:
                        _a.sent();
                        return [2, new Promise(function (resolve, reject) {
                                var appInfo = getNativeApplicationInfo();
                                if (!appInfo) {
                                    return reject(new Error("NativeAppInfo API is not available"));
                                }
                                appInfo.getAppVersion(resolve, reject);
                            })];
                }
            });
        });
    }
    exports.getAppVersion = getAppVersion;
    function getAppVersionNumber() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, NativeHelper_1.ensureNativeReady)()];
                    case 1:
                        _a.sent();
                        return [2, new Promise(function (resolve, reject) {
                                var appInfo = getNativeApplicationInfo();
                                if (!appInfo) {
                                    return reject(new Error("NativeAppInfo API is not available"));
                                }
                                appInfo.getAppVersionNumber(resolve, reject);
                            })];
                }
            });
        });
    }
    exports.getAppVersionNumber = getAppVersionNumber;
    function isVersionGreaterOrEqualTo(versionToTest, versionToTestAgainst) {
        if (!versionToTest || !versionToTestAgainst) {
            return false;
        }
        var versionToTestParts = versionToTest.split(".").map(function (v) { return parseInt(v, 10); });
        var versionToTestAgainstParts = versionToTestAgainst.split(".").map(function (v) { return parseInt(v, 10); });
        return innerIsVersionGreaterOrEqualTo(versionToTestParts, versionToTestAgainstParts, 0);
    }
    exports.isVersionGreaterOrEqualTo = isVersionGreaterOrEqualTo;
    function innerIsVersionGreaterOrEqualTo(versionToTest, versionToTestAgainst, index) {
        if (isNaN(versionToTestAgainst[index])) {
            return true;
        }
        else if ((versionToTest[index] || 0) > (versionToTestAgainst[index] || 0)) {
            return true;
        }
        else if (versionToTest[index] < (versionToTestAgainst[index] || 0)) {
            return false;
        }
        else {
            return innerIsVersionGreaterOrEqualTo(versionToTest, versionToTestAgainst, index + 1);
        }
    }
});
//# sourceMappingURL=NativeApplicationInfo.js.map;
